// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/airspeeds.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/airspeeds/ias-cas-tas.js';

mount([g0]);
